import script from "./ageList.vue?vue&type=script&setup=true&lang=js"
export * from "./ageList.vue?vue&type=script&setup=true&lang=js"

import "./ageList.vue?vue&type=style&index=0&id=6fac374b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fac374b"]])

export default __exports__